export default {
    it: {
        "title": "Il tuo questionario"
    },
    en: {
        "title": "Your survey"
    }
}